import { create } from 'apisauce'
import { getBackendUrls } from '../../config/backendEnv'

const api = create({
  baseURL: getBackendUrls().oikos,
})

let actorEmail = ''

export function setOikosActorEmail(email) {
  actorEmail = String(email || '').trim()
}

function requestReadsNf(action, table) {
  return String(table || '') === 'nf' && (action === 'get' || action === 'get_nf')
}

function urlReadsNf(url) {
  const text = String(url || '')
  const table = /(?:^|[?&])table=nf(?:&|$)/.test(text)
  const action = /(?:^|[?&])action=get(?:_nf)?(?:&|$)/.test(text)
  return table && action
}

api.addRequestTransform((request) => {
  const email = actorEmail
  if (!email) return

  const url = String(request.url || '')
  if (urlReadsNf(url) && !/(?:^|[?&])actor_email=/.test(url)) {
    const join = url.includes('?') ? '&' : '?'
    request.url = `${url}${join}actor_email=${encodeURIComponent(email)}`
  }

  const { params } = request
  if (params && typeof params === 'object' && requestReadsNf(params.action, params.table) && !params.actor_email) {
    params.actor_email = email
  }

  const { data } = request
  if (data && typeof data === 'object' && !(typeof FormData !== 'undefined' && data instanceof FormData) && requestReadsNf(data.action, data.table) && !data.actor_email) {
    data.actor_email = email
  }
})

api.addResponseTransform(response => {
  if (!response.ok) throw response
})

export default api
